import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/mixins';

export const FeedbackForm = styled.form`
	padding: 10px 25px 25px;
	min-height: 200px;
`;

export const Head = styled.h4`
	position: absolute;
	top: 20px;
	right: 50%;
	z-index: 1000;
	text-align: center;
	transform: translateX(50%);
	font-size: 14px;
	width: 100%;
	max-width: 80%;

	${breakpoint.greaterThan('mobile')`
	  font-size: 16px;
	  white-space: nowrap;
  `}
`;

export const Title = styled.div`
	text-align: center;
	margin-bottom: 30px;

	h5 {
		margin-bottom: 5px;
	}

	h6 {
		font-weight: 300;
		color: #737d83;
		margin-bottom: 1em;
	}
`;

export const EmojiList = styled.div`
	text-align: center;
	margin-bottom: 1.5rem;
`;

export const EmojiPlace = styled.div`
	display: inline-block;
	vertical-align: middle;
	margin: 0 4px;

	button {
		background-color: transparent;
		border: 0;
		padding: 0;
		display: block;
		position: relative;
		will-change: transform;
		user-select: none;

		${(p) =>
			p.$disabled
				? css`
						cursor: auto;
				  `
				: css`
						cursor: pointer;
				  `}

		img {
			width: 32px;
			height: 32px;
			filter: grayscale(1);
			transition: 0.5s ${(p) => p.theme.transition.function};

			${(p) =>
				p.$checked &&
				css`
					filter: grayscale(0);
					transform: scale(1.25);
				`}
		}

		&:hover {
			img {
				filter: grayscale(0);
			}
		}
	}
`;

export const Comment = styled.div`
	margin: 1.5rem 0 0.5rem;
	display: flex;
	direction: rtl;

	& > div {
		width: 100%;
	}

	img {
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 100%;
		margin-left: 10px;
	}

	textarea {
		border: 0;
		max-height: 40px;
		min-height: 60px;
		border-radius: ${(p) => p.theme.button.radius}px;
		background-color: ${(p) => p.theme.color.bgGray};
		appearance: none;
		width: 100%;
		padding: 10px 20px;
		font-size: 13px;
		/* line-height: 18px; */
		color: ${(p) => p.theme.color.grayTextColor};
		outline: none;
		min-height: 100px;
	}
`;

export const CommentText = styled.div`
	position: relative;
	margin: 0 0 3rem;
`;

export const CommentBody = styled.div`
	position: relative;
	background-color: #f0f3f5;
	color: #737d83;
	padding: 1rem 18px;
	line-height: 1.4;
	font-size: 1rem;
	border-radius: 15px;

	&:before {
		content: '';
		position: absolute;
		z-index: -1;
		top: 100%;
		right: 2rem;
		width: 22px;
		height: 12px;
		background-size: 20px 12px;
		/* background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' …odd' d='M.37 0S21.754 23 32 23c-5.562-11.417 0-23 0-23H.37z'/%3E%3C/svg%3E); */
	}
`;

export const CommnetHeader = styled.div`
	right: 0;
	position: absolute;
	bottom: -30px;

	img {
		display: block;
		width: 24px;
		height: 24px;
		object-fit: cover;
		border-radius: 100%;
	}
`;

export const Footer = styled.div`
	text-align: center;

	button.list {
		width: auto;
		margin: 0 auto 1rem;
		padding: 0.25rem 1.5rem;
		border-color: #888;
		color: #666;

		${(p) =>
			p.$disabled &&
			css`
				opacity: 0.5;
			`}
	}
`;
